
import {
  computed,
  defineComponent,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import { usePaginationData } from '~/composables';

export default defineComponent({
  props: {
    pagesCount: {
      type: Number,
      default: null,
    },
    marginPages: {
      type: Number,
      default: 1,
    },
    pageRange: {
      type: Number,
      default: 3,
    },
  },
  setup(props) {
    const { app } = useContext();
    const route = useRoute();
    const { currentPage } = usePaginationData();

    // TODO: Extract to separate file
    const pages = computed(() => {
      const items = [];
      const setPageItem = (index) => {
        const page = {
          index,
          content: index + 1,
          selected: index === currentPage.value - 1,
        };
        items[index] = page;
      };
      if (props.pagesCount <= props.pageRange) {
        for (let i = 0; i < props.pagesCount; i += 1) {
          setPageItem(i);
        }
      } else {
        const halfPageRange = Math.floor(props.pageRange / 2);
        const setBreakView = (index) => {
          const breakView = {
            index,
            disabled: true,
            breakView: true,
          };
          items[index] = breakView;
        };
        // 1st - loop thru low end of margin pages
        for (let i = 0; i < props.marginPages; i += 1) {
          setPageItem(i);
        }
        //   // 2nd - loop thru selected range
        let selectedRangeLow = 0;
        if (currentPage.value - halfPageRange > 0) {
          selectedRangeLow = currentPage.value - 1 - halfPageRange;
        }
        let selectedRangeHigh = selectedRangeLow + props.pageRange - 1;
        if (selectedRangeHigh >= props.pagesCount) {
          selectedRangeHigh = props.pagesCount - 1;
          selectedRangeLow = selectedRangeHigh - props.pageRange + 1;
        }
        for (
          let i = selectedRangeLow;
          i <= selectedRangeHigh && i <= props.pagesCount - 1;
          i += 1
        ) {
          setPageItem(i);
        }
        // Check if there is breakView in the left of selected range
        if (selectedRangeLow > props.marginPages) {
          setBreakView(selectedRangeLow - 1);
        }
        // Check if there is breakView in the right of selected range
        if (selectedRangeHigh + 1 < props.pagesCount - props.marginPages) {
          setBreakView(selectedRangeHigh + 1);
        }
        //   // 3rd - loop thru high end of margin pages
        for (
          let i = props.pagesCount - 1;
          i >= props.pagesCount - props.marginPages;
          i -= 1
        ) {
          setPageItem(i);
        }
      }
      return items;
    });

    const getRoute = (page) => {
      return app.localePath({
        params: {
          ...route.value.params,
        },
        query: {
          ...route.value.query,
          page,
        },
      });
    };

    return {
      pages,
      currentPage,
      getRoute,
    };
  },
});
